// Register Modal
import React, { useState } from "react";
import styled from "styled-components";
import Auth from "../ApiServices/Auth";
import Modal from "react-modal";
Modal.setAppElement("#root");
export default function RegisterModal(props) {
  const { RegisterModalIsOpen, setRegisterModalIsOpen, setModalIsOpen } = props;
  const [Name, setName] = useState(null);
  const [MobileNo, setMobileNo] = useState(null);
  const [Email, setEmail] = useState(null);
  const [Password, setPassword] = useState(null);
  const [ConfirmPassword, setConfirmPassword] = useState(null);
  const handleNameChange = (e) => {
    setName(e.target.value);
  };
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const handleNumberChange = (e) => {
    setMobileNo(e.target.value);
  };
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };
  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };
  const user = {
    username: Name,
    email: Email,
    password: Password,
  };
  const handleLogin = () => {
    Auth.Signup(user)
      .then()
      .catch((err) => {});
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    handleLogin();
    setRegisterModalIsOpen(false);
  };
  return (
    <ModalS
      isOpen={RegisterModalIsOpen}
      onRequestClose={() => setRegisterModalIsOpen(false)}
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.9)",
        },
      }}
    >
      <div>
        <Form onSubmit={handleSubmit}>
          <Label>Register</Label>
          <FormField>
            <InputLabel>Name/Contact</InputLabel>
            <br />
            <InputField
              type="text"
              placeholder="Enter your Name/Company Name"
              value={Name}
              onChange={handleNameChange}
            ></InputField>
          </FormField>
          <FormField>
            <InputLabel>E-mail</InputLabel>
            <br />
            <InputField
              type="email"
              placeholder="Enter your email address"
              value={Email}
              onChange={handleEmailChange}
            ></InputField>
          </FormField>
          <FormField>
            <InputLabel>Moblie no.</InputLabel>
            <br />
            <InputField
              type="tel"
              placeholder="Enter your Mobile number"
              value={MobileNo}
              onChange={handleNumberChange}
            ></InputField>
          </FormField>
          <FormField>
            <InputLabel>Password</InputLabel>
            <br />
            <InputField
              type="password"
              placeholder="Enter your password"
              value={Password}
              onChange={handlePasswordChange}
            ></InputField>
          </FormField>
          <FormField>
            <InputLabel>Confirm Password</InputLabel>
            <br />
            <InputField
              type="password"
              placeholder="Enter same password again"
              value={ConfirmPassword}
              onChange={handleConfirmPasswordChange}
            ></InputField>
          </FormField>
          <ButtonWrapper>
            <Button type="submit">Register</Button>
          </ButtonWrapper>
          <NewAccountWrapper>
            Already have a account?
            <Sbutton
              onClick={() => {
                setRegisterModalIsOpen(false);
                setModalIsOpen(true);
              }}
            >
              &#160;&#160;Login
            </Sbutton>
          </NewAccountWrapper>
        </Form>
      </div>
    </ModalS>
  );
}

const Sbutton = styled.button`
  outline: none;
  color: #004;
  background-color: #fff;
  font-size: 16px;
  border: none;
  &:hover {
    color: #00a;
  }
`;

const ModalS = styled(Modal)`
  width: 526px;
  height: auto;
  padding: 2em 4em 0 4em;
  border: black 1px solid;
  margin: 4em;
  z-index: 1000;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  margin-top: 0;
  @media (max-width: 480px) {
    font-size: 12px;
    width: 280px;
    max-height: 350px;
    min-height: 350px;
    margin: 0;
    padding: 2em;
  }
`;

const Form = styled.form`
  text-align: center;
  z-index: 1000;
  @media (max-width: 480px) {
  }
`;

const NewAccountWrapper = styled.p`
  margin-top: 1em;
  @media (max-width: 480px) {
    height: 17px;
  }
`;

const Button = styled.button`
  padding: 0.5em 3em;
  font-size: 1.2em;
  border: none;
  border-radius: 10px;
  background-color: #fff56c;
  margin-top: 2em;
`;

const ButtonWrapper = styled.div``;

const ForgetPasswordWrapper = styled.div`
  text-align: right;
  margin-top: 0.3em;
  @media (max-width: 480px) {
    height: 17px;
  }
`;

const InputField = styled.input`
  width: 100%;
  padding: 0.8em;
  margin-top: 0.1em;
  border-radius: 10px;
  @media (max-width: 480px) {
    padding: 0.5em;
    margin-top: 0.2em;
  }
`;

const InputLabel = styled.label`
  font-size: 1.3em;
  @media (max-width: 480px) {
    font-size: 18px;
    line-height: 22px;
  }
`;

const FormField = styled.section`
  text-align: left;
  margin-top: 0.5em;
`;

const Label = styled.label`
  text-align: center;
  width: 100%;
  font-size: 1.9em;
  @media (max-width: 480px) {
    font-size: 28px;
    line-height: 34px;
  }
`;
